export const subCategoryClothes = [
    "Camisas",
    "Faldas",
    "Leggings, shorts y joggers",
    "Vestidos",
    "Buzos y Chaquetas",
    "Zapatos",
    "Trajes de baño",
    "Conjuntos",
    "Medias",
    "Bodys",
    "Gorros",
    "Pijama",
    "Otros",
];

export const subCategoryToys = [
    "Figuras de acción y robots",
    "Muñecas",
    "Juegos de mesa",
    "Vehículos",
    "Juguetes de bebé",
    "Bloques y construcción",
    "Peluches",
    "Juguetes de rol",
    "Juegos de exterior",
    "Puntería",
    "Carpas",
    "Sets y accesorios",
    "Arte y manualidades",
    "Animales",
    "Rompecabezas",
    "Pistas de vehículos",
    "Vehículos a control remoto",
    "Set de playa y piscinas inflables",
    "Aviones, trenes y barcos",
    "Triciclos y tres ruedas",
    "Drones de juguete",
    "Otros",
];

export const subCategoryItems = [
    "Morrales",
    "Coches",
    "Biberones",
    "Extractor de leche",
    "Ollas",
    "Canguros",
    "Pañaleras",
    "Pañales",
    "Pañitos húmedos",
    "Cremas",
    "Útiles escolares",
    "Toallas",
    "Fórmula",
    "Esterilizador de biberones",
    "Calienta biberones",
    "Cuna",
    "Colchón de cuna",
    "Sabanas y Edredones",
    "Almohada",
    "Monitor para bebes",
    "Asiento para carro",
    "Asiento para baño",
    "Cepillos y peines",
    "Cortaúñas",
    "Cambiador de pañales",
    "Pañales de tela",
    "Lociones",
    "Aseo",
    "Almohada de lactancia",
    "Caminador",
    "Otros",
];

export const gender = ["Niña", "Niño", "Unisex"];

export const sizes = [
    "RN",
    "3M",
    "6M",
    "9M",
    "12M",
    "18M",
    "24M",
    "2T",
    "3T",
    "4T",
    "5T",
    "4",
    "6",
    "8",
    "10",
    "12",
    "14",
    "16",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
];

export const state = ["6/10", "7/10", "8/10", "9/10", "10/10"];

export const age = ["0-12M", "1-3A", "4-6A", "7-9A", "10-12A"];